import React, { useState, useEffect, useContext, useRef } from 'react';
import Button from '@mui/material/Button';
import config from '../../config/config';

import { OptionsContext } from '../../contexts/OptionsContext'

import { HotTable, HotColumn } from '@handsontable/react';
import { registerAllModules } from 'handsontable/registry';
import 'handsontable/styles/handsontable.min.css';
import 'handsontable/styles/ht-theme-main.min.css';

import './ManageOperators.css'

registerAllModules();

function ManageOptions() {
  const { care, updateCare, clinical, updateClinical, beds, updateBeds, amenities, updateAmenities, insurance, updateInsurance } = useContext(OptionsContext)
  const careTable = useRef(null)
  const clinicalTable = useRef(null)
  const bedsTable = useRef(null)
  const amenitiesTable = useRef(null)
  const insuranceTable = useRef(null)

  const handleEditCare = () => {
    let data = careTable.current.hotInstance.getData()
    console.log(data)
    updateCare(data)
  };

  const handleEditClinical = () => {
    let data = clinicalTable.current.hotInstance.getData()
    updateClinical(data)
  };

  const handleEditBeds = () => {
    let data = bedsTable.current.hotInstance.getData()
    updateBeds(data)
  };

  const handleEditAmenities = () => {
    let data = amenitiesTable.current.hotInstance.getData()
    updateAmenities(data)
  };

  const handleEditInsurance = () => {
    let data = insuranceTable.current.hotInstance.getData()
    updateInsurance(data)
  };

  return (
    <div>

      <p style={{ marginBottom: 10 }}>Types of Care</p>
      <HotTable
        ref={careTable}
        data={care}
        rowHeaders={true}
        colHeaders={true}
        navigableHeaders={true}
        tabNavigation={true}
        multiColumnSorting={true}
        headerClassName="htLeft"
        licenseKey='non-commercial-and-evaluation'
        minSpareRows={1}
      >
        <HotColumn title="ID" data="id" width="112" readOnly={true}></HotColumn>
        <HotColumn title="Option" data="option" width="112"></HotColumn>
      </HotTable>
      <Button style={{ marginTop: 10 }} onClick={() => { handleEditCare() }}>Submit</Button>


      <p style={{ marginBottom: 10, marginTop: 20 }}>Clinical Capablities</p>
      <HotTable
        ref={clinicalTable}
        data={clinical}
        rowHeaders={true}
        colHeaders={true}
        navigableHeaders={true}
        tabNavigation={true}
        multiColumnSorting={true}
        headerClassName="htLeft"
        licenseKey='non-commercial-and-evaluation'
        minSpareRows={1}
      >
        <HotColumn title="ID" data="id" width="112" readOnly={true}></HotColumn>
        <HotColumn title="Option" data="option" width="112"></HotColumn>
      </HotTable>
      <Button style={{ marginTop: 10 }} onClick={() => { handleEditClinical() }}>Submit</Button>


      <p style={{ marginBottom: 10, marginTop: 20 }}>Types of Beds</p>
      <HotTable
        ref={bedsTable}
        data={beds}
        rowHeaders={true}
        colHeaders={true}
        navigableHeaders={true}
        tabNavigation={true}
        multiColumnSorting={true}
        headerClassName="htLeft"
        licenseKey='non-commercial-and-evaluation'
        minSpareRows={1}
      >
        <HotColumn title="ID" data="id" width="112" readOnly={true}></HotColumn>
        <HotColumn title="Option" data="option" width="112"></HotColumn>
      </HotTable>
      <Button style={{ marginTop: 10 }} onClick={() => { handleEditBeds() }}>Submit</Button>


      <p style={{ marginBottom: 10, marginTop: 20 }}>Amenities</p>
      <HotTable
        ref={amenitiesTable}
        data={amenities}
        rowHeaders={true}
        colHeaders={true}
        navigableHeaders={true}
        tabNavigation={true}
        multiColumnSorting={true}
        headerClassName="htLeft"
        licenseKey='non-commercial-and-evaluation'
        minSpareRows={1}
      >
        <HotColumn title="ID" data="id" width="112" readOnly={true}></HotColumn>
        <HotColumn title="Option" data="option" width="112"></HotColumn>
      </HotTable>
      <Button style={{ marginTop: 10 }} onClick={() => { handleEditAmenities() }}>Submit</Button>


      <p style={{ marginBottom: 10, marginTop: 20 }}>Insurances</p>
      <HotTable
        ref={insuranceTable}
        data={insurance}
        rowHeaders={true}
        colHeaders={true}
        navigableHeaders={true}
        tabNavigation={true}
        multiColumnSorting={true}
        headerClassName="htLeft"
        licenseKey='non-commercial-and-evaluation'
        minSpareRows={1}
      >
        <HotColumn title="ID" data="id" width="112" readOnly={true}></HotColumn>
        <HotColumn title="Option" data="option" width="112"></HotColumn>
      </HotTable>
      <Button style={{ marginTop: 10 }} onClick={() => { handleEditInsurance() }}>Submit</Button>
    </div>
  )
}

export default ManageOptions
